import { Component, Input, OnInit, ViewEncapsulation, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { lstComparison } from '@core/configs/title-setting.config';
import { InputType, SearchType } from '@core/models/enums';
import { conditionItemModel, InputParams, LazyTreeNode, SearchParams, TreeNode } from '@core/models/models';
import { cloneDeep } from 'lodash';
import { COMMON_TEXT, SCREEN_TITLE_CONFIG } from '@core/constants';
@Component({
  selector: 'caremoni-condition-item',
  templateUrl: './condition-item.component.html',
  styleUrls: ['./condition-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConditionItemComponent implements OnInit,OnDestroy {
  @Input() isEditTtlSetting:boolean = false;
  @Input() isAllowRemoveCondition:boolean = false;
  @Input() panrentColName:string = "";
  @Input() treeViewNode: TreeNode[] = [];
  @Input() treeViewList: LazyTreeNode[] = [];
  @Input() notValidIds: any[] = [];
  @Input() officecd: string = "";
  @Input() conditionItem: conditionItemModel = new conditionItemModel();
  @Input() isShowKirokuCondition: boolean = false;
  @Output() removeItem = new EventEmitter<any>();
  @Output() eventUpdateData = new EventEmitter<conditionItemModel>();

  SCREEN_TITLE_CONFIG = SCREEN_TITLE_CONFIG;
  lstComparison = lstComparison;
  beforeIM: number = 0;
  operatorsNotForString: any[] = ['greater_than', 'less_than'];
  defaultComparison = 'like';

  paramsForTreeNode: SearchParams = {
    type: SearchType.combo,
    cssStyle: { width: '100%', height: '40px', 'font-size': '0.875rem' },
    readonly: false,
    disabled: false,
    maxLength: 100,
    defaultValue: '',
    comboDisplayText: 'name',
    objectData: {
      "treeViewNode": this.treeViewNode,
      "treeViewList": this.treeViewList,
      "selectedNode": this.conditionItem
    }
  };

  paramsForComparison: SearchParams = {
    type: SearchType.combo,
    placeholder: '',
    isFilter: false,
    cssStyle: { height: '40px', width: '100%', 'font-size': '14px' },
    readonly: false,
    disabled: false,
    comboDisplayText: 'name',
    defaultValue: '',
    dataSource: lstComparison
  };
  inputParams: InputParams = {
    readonly: true,
    disabled: false,
    type: InputType.text
  }

  paramsForItems: any = {
    type: InputType.text,
    borderFill: true,
    maxLength: 200
  };

  itemValues: string[] = [];
  keyChangeItem: string = "";
  placeholder: string = "";
  isShowComplete: Boolean = true;

  constructor(
    private cdr: ChangeDetectorRef
  ) {

  }
  ngOnDestroy(): void {
    if (this.paramsForComparison && this.paramsForComparison.objectData) {
      this.paramsForComparison.objectData.treeViewNode = null;
      this.paramsForComparison.objectData.treeViewList = null;
      this.paramsForComparison.objectData.selectedNode = null;
      this.paramsForComparison.objectData = null;
    }
    if (this.paramsForTreeNode && this.paramsForTreeNode.objectData) {

      this.paramsForTreeNode.objectData.treeViewNode = null;
      this.paramsForTreeNode.objectData.treeViewList = null;
      this.paramsForTreeNode.objectData.selectedNode = null;
      this.paramsForTreeNode.objectData = null;
    }
  }
  
  //#region event angular 
  ngOnInit(): void {
    this.bindData();
  }
  bindData(){
    this.placeholder = COMMON_TEXT.SEARCH;
    if(this.paramsForTreeNode.objectData.selectedNode.itemname != "") this.bindDataAns();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.detectChanges(); 
    this.keyChangeItem = this.conditionItem.ttlcd + this.conditionItem.ttlkbn + this.conditionItem.itemid;
    this.paramsForComparison.defaultValue = this.lstComparison.find((x:any) => x.value == this.conditionItem.comparison)?.name || "";
    this.paramsForComparison.selected = this.lstComparison.find((x:any) => x.value == this.conditionItem.comparison)?.name || "";

    if (this.conditionItem.im == 2) {
      // im = 2: case number
      this.paramsForComparison.dataSource = lstComparison;
    } else {
      // im != 2: case string
      this.paramsForComparison.dataSource = lstComparison.filter((item:any) => !this.operatorsNotForString.includes(item.value));
    }

    this.beforeIM = this.conditionItem.im ?? 0;
    this.paramsForComparison = cloneDeep(this.paramsForComparison);

    this.paramsForTreeNode.objectData.treeViewNode = this.treeViewNode;
    this.paramsForTreeNode.objectData.treeViewList = this.treeViewList;
    this.paramsForTreeNode.objectData.selectedNode = this.conditionItem;  

    this.paramsForTreeNode = cloneDeep(this.paramsForTreeNode);
    if(this.conditionItem.comparison == SCREEN_TITLE_CONFIG.HAS_RECORD) this.isShowComplete = false;
  }
  //#endregion event angular

  //#region treenode
  async onUpdateDataCondition(event: any) {
    this.conditionItem.dockbn = event.dockbn;
    this.conditionItem.ttlkbn = event.ttlkbn;
    this.conditionItem.ttlcd = event.ttlcd;
    this.conditionItem.itemid = event.itemid;
    this.conditionItem.notekbn = event.notekbn;
    this.conditionItem.dockbn = event.dockbn;
    this.conditionItem.itemname = event.itemname;
    this.conditionItem.childids = event.childids;
    console.log("conditionItem", event);
    this.keyChangeItem = this.conditionItem.ttlcd + this.conditionItem.ttlkbn + this.conditionItem.itemid;
    this.eventUpdateData.emit(this.conditionItem)

    if (event.im == 2) {
      // im = 2: case number
      this.paramsForComparison.dataSource = lstComparison;
    } else {
      // im != 2: case string
      this.paramsForComparison.dataSource = lstComparison.filter((item:any) => !this.operatorsNotForString.includes(item.value));

      // Trường hợp trước đó mode IM  = 2 (number) và đang chọn so sánh 'greater_than', 'less_than',
      // sau đó chuyển sang IM != 2 (string) thì auto chuyển option comparison sang default 'like'
      if (this.operatorsNotForString.includes(this.conditionItem.comparison) && this.beforeIM == 2) {
        this.conditionItem.comparison = this.defaultComparison;
        this.paramsForComparison.defaultValue = this.lstComparison.find((x:any) => x.value == this.defaultComparison)?.name || "";
        this.paramsForComparison.selected = this.lstComparison.find((x:any) => x.value == this.defaultComparison)?.name || "";
        this.paramsForComparison = cloneDeep(this.paramsForComparison);
      }

    }
    this.beforeIM = event.im;
    this.paramsForComparison = cloneDeep(this.paramsForComparison);
    this.bindDataAns();
  }

  bindDataAns(){
    let itemnamechildArr = this.paramsForTreeNode.objectData.selectedNode.itemname.split('>');
    //Chỉ bind data ans khi có 3 cấp.
    if(itemnamechildArr.length < 3) return;
    this.paramsForTreeNode.objectData.treeViewNode.forEach((yotei: any) =>{
      yotei.nodes.forEach((nodelv1 : any) => {
        if(nodelv1.label == itemnamechildArr[0].trim()){
          nodelv1.nodes.forEach((nodelv2: any) => {
            if(nodelv2.label == itemnamechildArr[1].trim()){
              nodelv2.nodes.forEach((nodelv3: any) => {
                if(nodelv3.label == itemnamechildArr[2].trim()) {
                  this.itemValues = [...nodelv3.ans.map((x:any) => x.lbl)];
                  return;
                }
              });
              return;
            }
          });
          return;
        }
      });
    })
  }
  //#endregion treenode

  //#region conditon
  onFilterCondition(data: any[]) {
    if (data && data.length == 1) {
      if(data[0].value == SCREEN_TITLE_CONFIG.HAS_RECORD){
        this.isShowComplete = false;
        let itemNameArr = this.paramsForTreeNode.objectData.selectedNode.itemname.split('>');
        this.paramsForTreeNode.objectData.selectedNode.itemname = `${itemNameArr[0]}>${itemNameArr[1]}`
        this.paramsForTreeNode = cloneDeep(this.paramsForTreeNode);
        this.conditionItem.comparison = data[0].value;
        this.conditionItem.val = '';
        this.conditionItem.itemname =  this.paramsForTreeNode.objectData.selectedNode.itemname;
        this.paramsForComparison.defaultValue = this.lstComparison.find((x:any) => x.value == this.conditionItem.comparison)?.name || "";
        this.paramsForComparison.selected = this.lstComparison.find((x:any) => x.value == this.conditionItem.comparison)?.name || "";
        this.paramsForComparison = cloneDeep(this.paramsForComparison);
      }
      else{
        this.isShowComplete = true;
        this.conditionItem.comparison = data[0].value;
        this.paramsForComparison.defaultValue = this.lstComparison.find((x:any) => x.value == this.conditionItem.comparison)?.name || "";
        this.paramsForComparison.selected = this.lstComparison.find((x:any) => x.value == this.conditionItem.comparison)?.name || "";
        this.paramsForComparison = cloneDeep(this.paramsForComparison);
      }
    }
    this.eventUpdateData.emit(this.conditionItem)
  }
  //#endregion condition

  //#region item
  onChangeItemValue(event: any) {
    if (typeof event == 'object') {
        this.conditionItem.val = event?.value;
    } else {
        this.conditionItem.val = event ?? "";
    }
    this.eventUpdateData.emit(this.conditionItem)
  }
  //#endregion item

  //#region button
  onRemove(id: any) {
    if (this.isAllowRemoveCondition) {
      let itemRemoved = {
        parentColName: this.panrentColName,
        childId: id
      }
      this.removeItem.emit(itemRemoved);
    }
  }
  //#endregion button
}
